;(function($) {

    'use strict';

    var pluginName = 'promotion';

    var defaults = {
        // successful application class applied to $element
        appliedClass: 'applied',
        // apply promo button/link selector
        applyButtonSelector: '.apply-promo',
        // selector of code display element
        codeLabelSelector: '.promo-label',
        // error selector
        errorSelector: '.error',
        // promo input selector
        inputSelector: '.input-promo',
        // button loading class
        loadingClass: 'loading',
        // remove promo button/link selector
        removeButtonSelector: '.remove-promo'
    };

    /**
     * Promotion
     * @constructor
     * @param {Object} target
     * @param {Object} options (Optional)
     */
    function Promotion(element, options) {
        this.$element = $(element);
        this.opts = $.extend({}, defaults, options);

        this._init();
    }

    /**
     * Init
     * @private
     */
    Promotion.prototype._init = function() {
        this.$input = this.$element.find( this.opts.inputSelector + ':first' );
        this.$applyButton = this.$element.find( this.opts.applyButtonSelector + ':first' );
        this.$removeButton = this.$element.find( this.opts.removeButtonSelector + ':first' );
        this.$label = this.$element.find( this.opts.codeLabelSelector + ':first' );
        this.$error = this.$element.find( this.opts.errorSelector + ':first');
        this.code = '';

        this.$applyButton.on('click', $.proxy(this._bindApply, this));
        this.$removeButton.on('click', $.proxy(this._bindRemove, this));
    };

    /**
     * Bind apply
     * @private
     */
    Promotion.prototype._bindApply = function(event){
        if(event.target.nodeName === 'A') {
            event.preventDefault();
        }

        var that = this;

        that.$applyButton.disable().addClass(that.opts.loadingClass);
        that._clearError('');

        $.get('/promo/apply/' + that.$input.val(), null, null, 'json')
            .fail($.proxy(that._applyFailure, that))
            .always(function(){
                that.$applyButton.enable().removeClass(that.opts.loadingClass);
            })
            .done(function(response){
                if(response.discount === undefined) {
                    // no discount
                    return;
                }

                // save code
                that.code = response.code;

                // apply block attributes, clear input
                that.$input.val('');
                that.$element.addClass( that.opts.appliedClass );
                that.$label.text( that.code );

                $(window).trigger('applied.promo', [response.discount, that.code])
            });
    };

    /**
     * Bind remove
     * @private
     */
    Promotion.prototype._bindRemove = function(event){
        if(event.target.nodeName === 'A') {
            event.preventDefault();
        }

        var that = this;

        that.$removeButton.disable().addClass(that.opts.loadingClass);

        $.get('/promo/remove', null, null, 'json')
            // .fail($.proxy(that._applyFailure, this))
            .always(function(){
                that.$removeButton.enable().removeClass(that.opts.loadingClass);
            })
            .done(function(response){
                that.$element.removeClass( that.opts.appliedClass );
                that.$label.text('');

                $(window).trigger('removed.promo');
            });
    };

    /**
     * Apply AJAX failure
     * @private
     */
    Promotion.prototype._applyFailure = function(xhr){
        if(xhr.responseText !== undefined) {
            this._showError(xhr.responseText);
        }
    };

    /**
     * Show error message
     * @private
     */
    Promotion.prototype._showError = function(msg) {
        this.$error.html(msg);
    };

    /**
     * Clear error message
     * @private
     */
    Promotion.prototype._clearError = function() {
        this.$error.html('');
    };

    /**
     * jQuery plugin wrapper
     */
    $.fn.promotion = function(options) {
        return this.each(function(){
            var plugin = $.data(this, pluginName);

            if(!plugin) {
                $.data(this, pluginName, new Promotion(this, options));
            }
        });
    };

})(jQuery);